import { useEffect } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { useMutation } from '@tanstack/react-query';
import ProjectApi from '@/api/ProjectApi';
import PresetApi from '@/api/PresetApi';

export function useUpdateProject() {
	const dispatch = useTypedDispatch();

	const { project, preset, options, storeId } = useTypedSelector(
		(state) => state.creator
	);

	const getPresetMutation = useMutation({
		mutationFn: PresetApi.getWithoutStore,
		onSuccess: (preset) => {
			dispatch(creatorActions.syncPreset(preset));
		},
	});

	const getProjectMutation = useMutation({
		mutationFn: ProjectApi.mutationGetOne,
		onSuccess: (project) => {
			dispatch(creatorActions.syncProject(project));
		},
	});

	useEffect(() => {
		if (project.id) getProjectMutation.mutate(project.id);
		if (preset.id) getPresetMutation.mutate({ presetId: preset.id, storeId });
	}, [options.syncProjectCounter]);
}
